var map = {
	"./tech-excel.svg": 1902,
	"./tech-git.svg": 1903,
	"./tech-google-sheets.svg": 1904,
	"./tech-gray-chatgpt.svg": 1323,
	"./tech-gray-excel.svg": 1324,
	"./tech-gray-git.svg": 1325,
	"./tech-gray-google-sheets.svg": 1326,
	"./tech-gray-jupyter.svg": 1327,
	"./tech-gray-multiple.svg": 1328,
	"./tech-gray-other.svg": 1329,
	"./tech-gray-powerbi.svg": 1330,
	"./tech-gray-python.svg": 1331,
	"./tech-gray-r.svg": 1332,
	"./tech-gray-sql.svg": 1333,
	"./tech-gray-tableau.svg": 1334,
	"./tech-gray-theory.svg": 1335,
	"./tech-powerbi.svg": 1905,
	"./tech-python (2).svg": 1906,
	"./tech-python.svg": 1907,
	"./tech-r.svg": 1908,
	"./tech-responsive-artificial-intelligence.svg": 542,
	"./tech-responsive-chatgpt.svg": 1270,
	"./tech-responsive-data.svg": 1271,
	"./tech-responsive-excel.svg": 1272,
	"./tech-responsive-git.svg": 1273,
	"./tech-responsive-google-sheets.svg": 1274,
	"./tech-responsive-jupyter.svg": 1275,
	"./tech-responsive-langchain.svg": 1276,
	"./tech-responsive-multiple.svg": 1277,
	"./tech-responsive-powerbi.svg": 1278,
	"./tech-responsive-powerpoint.svg": 1279,
	"./tech-responsive-python.svg": 1280,
	"./tech-responsive-r.svg": 1281,
	"./tech-responsive-sql.svg": 1282,
	"./tech-responsive-tableau.svg": 1283,
	"./tech-responsive-theory.svg": 1284,
	"./tech-sql.svg": 1909,
	"./tech-tableau.svg": 1910,
	"./tech-theory.svg": 1911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4027;